import { Backdrop, CircularProgress, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
    loading?: boolean;
    fetching?: boolean | undefined;
    zIndex?: number;
    text?: string;
    children?: ReactNode;
}
function BackdropComponent({ loading, fetching, zIndex, text, children }: Props) {
    return (
        <Backdrop
            sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                color: '#fff',
                zIndex: zIndex ? zIndex : (theme) => theme.zIndex.drawer + 1
            }}
            open={loading || !!fetching}
        >
            <Stack direction="column" spacing={2} alignItems="center">
                <CircularProgress color="primary" />
                {text && <Typography variant="body1">{text}</Typography>}
                {children}
            </Stack>
        </Backdrop>
    );
}

export default BackdropComponent;
